import {TextInput as Text} from './TextInput';

export {Text};
